import { alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_CONTENT_HEIGHT } from '../../../styles/constants';
import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles()((theme) => {
  const blockBorder = alpha(
    theme.palette.primary.main,
    theme.palette.mode === 'dark' ? 0.5 : 0.4,
  );

  return {
    modalDndSurface: {
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
    },
    list: {
      maxHeight: `calc(${MAX_CONTENT_HEIGHT} - 130px)`,
      overflowY: 'auto',
      paddingRight: theme.spacing(0.5),
    },
    block: {
      borderRadius: theme.spacing(1),
      border: `1px solid ${blockBorder}`,
      overflow: 'visible',
      backgroundColor: theme.palette.background.paper,
      boxShadow: `0 1px 4px ${alpha(theme.palette.common.black, UiAlpha.Subtle)}`,
    },
    blockHeaderRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      paddingLeft: theme.spacing(1),
      width: '100%',
      minWidth: 0,
    },
    mergeZone: {
      padding: theme.spacing(1),
      minHeight: theme.spacing(5.5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      transition:
        'background-color 0.15s ease, border-color 0.15s ease, min-height 0.18s ease-out',
      borderRadius: theme.spacing(0.5),
      border: 'none',
      width: '100%',
      boxSizing: 'border-box',
    },
    mergeZoneInline: {
      padding: theme.spacing(1, 2),
      paddingLeft: 0,
      minHeight: 0,
      margin: 0,
      width: '100%',
      justifyContent: 'flex-start',
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
    },
    rowAfterFirst: {
      marginTop: theme.spacing(1),
    },
    rowDragHandle: {
      cursor: 'grab',
      touchAction: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      minWidth: 44,
      minHeight: 44,
      margin: theme.spacing(-0.5, 0),
      padding: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      borderRadius: theme.spacing(0.75),
      color: theme.palette.text.secondary,
      '&:active': {
        cursor: 'grabbing',
      },
    },
    rowDragging: {
      borderRadius: theme.spacing(0.75),
      border: `2px dashed ${theme.palette.primary.main}`,
      backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Subtle),
      boxShadow: `0 0 0 1px ${alpha(theme.palette.primary.main, 0.35)}`,
    },
    blockDragHandle: {
      cursor: 'grab',
      touchAction: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(0.5),
      flexShrink: 0,
      minWidth: 44,
      minHeight: 44,
      padding: theme.spacing(0.5),
      margin: theme.spacing(-0.5, 0),
      borderRadius: theme.spacing(0.75),
      color: theme.palette.text.secondary,
      '&:active': {
        cursor: 'grabbing',
      },
    },
    blockDragHandleDragging: {
      border: `2px dashed ${theme.palette.primary.main}`,
      backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Subtle),
      boxShadow: `0 0 0 1px ${alpha(theme.palette.primary.main, 0.35)}`,
    },
    dragLayerCard: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      maxWidth: 'none',
      padding: theme.spacing(1, 1.5),
      borderRadius: theme.spacing(1),
      border: `2px dashed ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[8],
      pointerEvents: 'none',
      boxSizing: 'border-box',
    },
    dropZoneOuter: {
      padding: theme.spacing(0.5),
      boxSizing: 'border-box',
    },
    dropZoneOuterInline: {
      flex: 1,
      minWidth: 0,
      paddingLeft: 0,
    },
    dropZoneInner: {
      borderRadius: theme.spacing(0.5),
      transition:
        'background-color 0.15s ease, border-color 0.15s ease, min-height 0.18s ease-out',
      boxSizing: 'border-box',
      border: 'none',
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column-reverse',
        '& > button': {
          width: '100%',
        },
      },
    },
  };
});
